
(() => {
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-cs-purchase]').forEach((tools) => {
      if (tools.dataset.csBound) return;
      tools.dataset.csBound = 'true';
      let variants = [];
      try { variants = JSON.parse(tools.querySelector('[data-cs-variants]').textContent); } catch (_) {}
      const refresh = () => {
        const form = document.getElementById(tools.dataset.formId);
        const product = tools.closest('.product-page');
        const qtyInput = product?.querySelector('input[name="quantity"]');
        const enteredQty = Number(qtyInput?.value);
        const quantity = Number.isSafeInteger(enteredQty) && enteredQty > 0 ? String(enteredQty) : '1';
        const variantId = form?.querySelector('[name="id"]')?.value || '';
        const variant = variants.find((v) => String(v.id) === variantId);
        tools.querySelectorAll('[data-cs-quote]').forEach((link) => {
          const url = new URL(link.getAttribute('href'), location.origin);
          url.searchParams.set('quantity', quantity);
          if (variantId) url.searchParams.set('variant', variantId);
          if (variant?.sku) url.searchParams.set('sku', variant.sku);
          else url.searchParams.delete('sku');
          if (variant?.title && variant.title !== 'Default Title') url.searchParams.set('option', variant.title);
          else url.searchParams.delete('option');
          link.href = url.pathname + url.search + url.hash;
        });
      };
      refresh();
      tools.closest('.product-page')?.addEventListener('input', refresh);
      tools.closest('.product-page')?.addEventListener('change', refresh);
      tools.querySelectorAll('[data-cs-quote]').forEach((link) => {
        link.addEventListener('click', refresh);
        link.addEventListener('contextmenu', refresh);
        link.addEventListener('pointerdown', refresh);
        link.addEventListener('focus', refresh);
      });
    });
    scope.querySelectorAll('[data-cs-copy]').forEach((button) => {
      if (button.dataset.csBound || !navigator.clipboard?.writeText) return;
      button.dataset.csBound = 'true';
      button.hidden = false;
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.csCopy);
          const feedback = button.parentElement.querySelector('[data-cs-copy-feedback]');
          feedback.textContent = button.dataset.csCopied;
          setTimeout(() => { feedback.textContent = ''; }, 2000);
        } catch (_) { /* The visible part number can still be selected manually. */ }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
